import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ApiService from '../../services/ApiService';
import LoadingPage from '../LoadingPage';

const JumpToDeal = ({ quoteId }) => {
  const history = useHistory();

  const fetchQuoteAndRedirect = () => {
    ApiService.get(`/db/EQS1/${quoteId}`).then(response => {
      history.push(`/db/EQS2/${response.data.dealId}/edit?oq=${quoteId}`);
    });
  };

  useEffect(() => {
    fetchQuoteAndRedirect();
  }, []);

  return <LoadingPage message="Fetching Quote" />;
};

export default JumpToDeal;
